class SearchZeroResultComponentController {
    constructor($sce, $state, $sanitize, settings, analyticsService, searchService) {
        this.$sce = $sce;
        this.$state = $state;
        this.$sanitize = $sanitize;
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
    }

    $onInit() {
        this.searchTerm = '';
        this.originalSearchTerm = this.$sanitize(this.$state.params.searchTerm);

        this.pageName = 'results';
        if (this.$state.current.name === 'shop.search.products') {
            this.pageName = 'products';
        } else if (this.$state.current.name === 'shop.search.specials') {
            this.pageName = 'specials';
        } else if (this.$state.current.name === 'shop.search.recipes') {
            this.pageName = 'recipes';
        } else if (this.$state.current.name === 'shop.search.articles') {
            this.pageName = 'articles';
        }

        this.analyticsService.push({
            data: {
                type: this.pageName,
                categories: this.searchService.categories || '',
                searchKeyword: this.originalSearchTerm,
                listKeywords: this.$state.params.multisearchItems,
                searchResult: [],
            },
            type: this.analyticsService.mapperTypes.search.result,
        });

        const emptyProductSearchMessageBeforeAfter = this.settings.search.zeroSearchResultsMessage.split('{search}');
        this.searchTerm = this.$state.params.searchTerm;
        this.emptyProductSearchMessageBefore = this.$sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[0]);
        this.emptyProductSearchMessageAfter = this.$sce.trustAsHtml(emptyProductSearchMessageBeforeAfter[1]);
    }
}

SearchZeroResultComponentController.$inject = ['$sce', '$state', '$sanitize', 'Settings', 'AnalyticsService', 'SearchService'];

const searchZeroResultComponentDefinition = {
    controller: SearchZeroResultComponentController,
    template: require('./search-zero-results.component.html').trim(),
};

module.exports = {
    SearchZeroResultComponentController,
    searchZeroResultComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-zero-results.component.js